module.exports = __webpack_public_path__ + "static/media/sur_platea.36ac180c.mp4";